module.exports = __webpack_public_path__ + "static/media/dark-menuu-logo.88255dfc.png";